import { render, staticRenderFns } from "./departmentListSection.vue?vue&type=template&id=7ac9fe46&scoped=true"
import script from "./departmentListSection.vue?vue&type=script&lang=js"
export * from "./departmentListSection.vue?vue&type=script&lang=js"
import style0 from "./departmentListSection.vue?vue&type=style&index=0&id=7ac9fe46&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ac9fe46",
  null
  
)

export default component.exports